<template>
  <div class="flex custom-auth-page">
    <template v-if="isDesktop">
      <span class="title-video"></span>
      <div class="video-back"></div>
      <div class="w-full h-100 video-container">
        <video autoplay muted loop>
          <source src="@/assets/video/video_safras.mp4" type="video/mp4" />
        </video>
      </div>
    </template>
    <div
      class="flex vx-row items-center justify-center bg-auth"
      :class="{ 'w-full no-gutter': !isDesktop, 'h-screen': !fromPopup }"
      id="page-lost-access"
    >
      <!-- <div class="mobile-btn-back">
        <button v-if="!isDesktop" @click="onClose" class="btn-close">
          <feather-icon icon="XIcon" />
        </button>
      </div> -->
      <div class="h-full">
        <VuePerfectScrollbar
          class="auth-content-scroll h-full"
          :settings="settings"
          :suppressScrollX="true"
        >
        <div class="w-full login-cont" :class="{'items-center': isDesktop}">
          <div slot="no-body" class="full-page-bg-color" :class="{'oversize': !isDesktop}">
            <div class="login-body">
              <div class="vx-col lg:block lg:w-1/1 mx-auto self-center logo-click" @click="onClose">
                <span class="back-login-button" v-if="!fromPopup">
                  <feather-icon icon="XIcon" svgClasses="w-6 h-6" />
                </span>
                <vx-tooltip :text="$t('LOGIN').Click_Back" position="bottom" delay=".1s">
                  <div class="logo-login mx-auto" :class="{'logo-login-mobile': !isDesktop}"></div>
                </vx-tooltip>
                <!-- <div
                  class="logo-login mx-auto"
                  :class="{ 'logo-login-mobile': !isDesktop }"
                ></div> -->
                <!-- <div class="logo-login mx-auto logo-login-mobile" v-if="!isDesktop"></div> -->
              </div>
              <div class="w-full center">
                <h3 class="mb-2">{{ $t("LOST_ACCESS").Title }} ?</h3>
              </div>
              <div
                class="vx-col sm:w-full md:w-full lg:w-1/1 mx-auto self-center pagecard"
              >
                <div class="">
                  <div class="vx-card__title mb-8">
                    <!-- <p>Perdeu o acesso a sua conta </p> -->
                  </div>
                  <div class="mensagem-tela">
                    <!-- <h6>Fale com o nosso atendimento pelo telefone:</h6>
                        <div class="help-desk-phone mt-3 mb-2">
                          <a :href="$t('LOST_ACCESS').Phone_href" class="w-full linkphone">
                            <feather-icon class="iconCall" icon="PhoneCallIcon" />
                            {{$t('LOST_ACCESS').Phone_Text}}
                          </a>
                        </div> -->
                    <!-- <div class="box box-info-icon">
                          <feather-icon class="mr-0 cursor-pointer" icon="MailIcon" />
                          {{$t('LOST_ACCESS').Email_field}} <a :href="$t('LOST_ACCESS').Mail_href">{{$t('LOST_ACCESS').Mail_Text}}</a>
                        </div> -->
                  </div>
                  <div class="options-contact" style="display:none;">
                    <ul class="centerx">
                      <li>
                        <vs-radio
                          v-model="emailCheckboxSelected"
                          vs-value="email"
                          >{{ $t("LOST_ACCESS").EmailCheckbox }}</vs-radio
                        >
                        <vs-radio
                          v-model="emailCheckboxSelected"
                          vs-value="outros"
                          >{{ $t("LOST_ACCESS").OtherCheckbox }}</vs-radio
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="contact1">
                    <template v-if="emailCheckboxSelected == 'email'">
                      <h6>{{ $t("LOST_ACCESS").ByEmail_Title }}</h6>
                      <vs-input
                        name="email"
                        id="email"
                        type="email"
                        v-validate="'required|email'"
                        icon-no-border
                        icon="icon icon-mail"
                        icon-pack="feather"
                        :label="$t('LOST_ACCESS').Email_field"
                        v-model="form.email"
                        class="w-full"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('email')"
                        >{{ errors.first("email") }}</span
                      >

                      <vs-input
                        v-validate="'required'"
                        data-vv-validate-on="blur"
                        :name="$t('LOST_ACCESS').Phone_field"
                        id="telefone"
                        type="phone"
                        icon-no-border
                        icon="icon icon-phone"
                        icon-pack="feather"
                        :label="$t('LOST_ACCESS').Phone_field"
                        v-model="form.phone"
                        class="w-full"
                        v-mask="'## #####-####'"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has($t('LOST_ACCESS').Phone_field)"
                        >{{ errors.first($t('LOST_ACCESS').Phone_field) }}</span
                      >

                      <div class="mensagem-email">
                        <vs-textarea
                          id="messagem"
                          :name="$t('LOST_ACCESS').Message_field"
                          v-validate="'required'"
                          data-vv-validate-on="blur"
                          class="w-full text-area-form"
                          height="100"
                          :label="$t('LOST_ACCESS').Message_field"
                          v-model="form.message"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has($t('LOST_ACCESS').Message_field)"
                          >{{ errors.first($t('LOST_ACCESS').Message_field) }}</span
                        >
                      </div>
                      <div class="flex flex-row-reverse">
                        <vs-button class="btn-login" @click="onSubmit" :disabled="errors.all().length > 0">
                          {{ $t("BUTTONS").RecoveryPassword }}
                        </vs-button>
                        <!-- <vs-button type="border" @click="onBack" class="btn-back">{{$t('BUTTONS').Back}}</vs-button> -->
                      </div>
                    </template>
                    <template v-else> </template>
                    <auth-links :fromPopup="fromPopup" :login="true" :register="true" :forgotPass="true"  @open-login="$emit('open-login')" @open-forgot-password="$emit('open-forgot-password')" @open-register="$emit('open-register')"></auth-links>
                  </div>
                </div>
              </div>
              <auth-footer-privacy
                @open-terms="
                  displayPopupTermsCondition = !displayPopupTermsCondition
                "
                @open-privacy="
                  displayPopupPrivacyPolicy = !displayPopupPrivacyPolicy
                "
              ></auth-footer-privacy>
            </div>
          </div>

        </div>
        </VuePerfectScrollbar>
      </div>
      <vs-popup
            :title="$t('HELP_PRIVACY_POLICY').Title"
            :active.sync="displayPopupPrivacyPolicy"
            class="privacy-policy-modal"
            :class="{ 'privacy-policy-modal-mobile': !isDesktop }"
          >
            <privacy-policy v-if="displayPopupPrivacyPolicy"></privacy-policy>
          </vs-popup>
          <vs-popup
            :title="$t('TERMS_USE').Title"
            :active.sync="displayPopupTermsCondition"
            class="terms-condition-modal"
            :class="{ 'terms-condition-modal-mobile': !isDesktop }"
          >
            <terms-use
              :displayActionButton="false"
              v-if="displayPopupTermsCondition"
            ></terms-use>
          </vs-popup>
    </div>
  </div>
</template>

<script>
import userService from "../../providers/userService";
import messagesNotifyHelper from "../../helpers/messages-notify-helper";
import AppConstants from "../../appConstants";
import AuthFooterPrivacy from "./AuthFooterPrivacy.vue";
import TermsUse from "./help/TermsUse.vue";
import PrivacyPolicy from "./help/PrivacyPolicy.vue";
import AuthLinks from './AuthLinks.vue';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Typewriter from 't-writer.js'
import router from "@/router";
import checkDeviceTypeHelper from "@/helpers/check-device-type-helper";

export default {
  props: {
    fromPopup: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AuthFooterPrivacy,
    TermsUse,
    PrivacyPolicy,
    AuthLinks,
    VuePerfectScrollbar
  },
  data() {
    return {
      emailCheckboxSelected: "email",
      form: {
        email: "",
        phone: "",
        message: ""
      },
      displayPopupTermsCondition: false,
      displayPopupPrivacyPolicy: false,
      settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.3,
          swipeEasing: true
        },
    };
  },
  mounted() {
    if (this.isDesktop) {
      const target = document.querySelector('.title-video')
      // console.log(target);
      const options = {
        loop: true,
        typeColor: 'white',
        typeSpeed: 80,
        deleteSpeed: 10,
      }

      const writer = new Typewriter(target, options)
        .changeCursorColor('white')
        .type('Safras & Mercado: A sua casa de análises do Brasil e América Latina')
        .rest(30000000)
        .clear()
        .start();
    }
    const emailStore = this.getEmailFromStore();
    if (emailStore) {
      this.form.email = emailStore;
    }
  },
  computed: {
    isDesktop() {
      return this.$store.state.isDesktop;
    }
  },
  methods: {
    onClose() {
      if (this.fromPopup) {
        this.$emit('close');
        return;
      }
      this.$router.push(AppConstants.NAVIGATION_PAGE_HOME);
    },
    onBack() {
      router.push({ path:  checkDeviceTypeHelper.getUrlLogin()});
    },
    getEmailFromStore() {
      return localStorage.email;
    },
    sendEmail() {
      userService
        .lostAccess(this.form, new URLSearchParams())
        .then(data => {
          this.$vs.dialog({
            // type: "confirm",
            color: "primary",
            title: `Mensagem enviada com sucesso !`,
            text: `Aguarde que nossa equipe entrará em contato para enviar seu novo acesso.`,
            accept: () => {
              // callback();
              this.form.email = "";
              this.form.phone = "";
              this.form.message = "";
              this.onBack();
            },
            acceptText: "OK",
            cancelText: "Fechar"
          });
        })
        .catch(error => {});
    },
    onSubmit() {
      // console.log(errors)
      this.$validator.validateAll().then(result => {
        if (result) {
          this.sendEmail();
        } else {
          messagesNotifyHelper.errorNotify(
            this.$t("LOST_ACCESS").Notify_Error_Title,
            this.$t("LOST_ACCESS").Notify_Error_Message
          );
        }
      });
    }
  }
};
</script>

<style lang="scss">
ul.centerx li label {
  margin-right: 20px;
}
button.btn-send {
  width: 100%;
  background-color: #678b0f !important;
  margin-top: 20px;
}
button.vs-component.vs-button.btn-send.vs-button-primary.vs-button-filled {
  background-color: #678b0f !important;
}
.box-login {
  width: 830px !important;
  min-height: 425px !important;
}
.mensagem-email {
  margin-top: 10px;
}
.contact1 {
  margin-top: 10px;
}
.mensagem-tela {
  margin-top: 10px;
}
.box.box-info-icon {
  margin-top: 10px;
}
a.phonecss {
  margin-top: 0;
  position: absolute;
  padding-left: 5px;
  font-weight: bold;
}
svg.feather.feather-phone-call {
  margin-top: 5px;
  position: absolute;
  margin-left: -20px;
}
.linkphone {
}
.btn-back {
  width: 120px;
  height: 40px;
  margin-top: 20px;
  margin-right: 10px;
}
.text-area-form {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
</style>
